import * as hookz from '@react-hookz/web';
import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useApp } from '#/app';
import { useInviteParams } from '#/features/user-invites';
import { useAuth0 } from '#/vendors/auth0';

export const AcceptInvitePage: React.FC = () => {
  const auth0 = useAuth0();
  const inviteParams = useInviteParams();
  const app = useApp();
  const handleRedirect = () => {
    auth0.login({
      authorizationParams: {
        screen_hint: 'signup',
        login_hint: inviteParams.params.email,
      },
    });
  };

  /*
  |------------------
  | Effects
  |------------------
  */

  hookz.useMountEffect(() => {
    app.setLoading(true);
    handleRedirect();
  });

  return (
    <React.Fragment>
      <Helmet>
        <title>Accept Invite to Joggr</title>
      </Helmet>
    </React.Fragment>
  );
};
